import { LOGOUT } from "@/components/access/ducks/Actions"
import { RECEIVE_ROLE_DATA_HEALTH } from "@/components/data/volunteer/ducks/Actions"

const defaultState = {
  dataHealthArray: [],
}

const volunteerDataReducer = (oldState = defaultState, action) => {
  Object.freeze(oldState)
  switch (action.type) {
    case LOGOUT:
      return defaultState

    case RECEIVE_ROLE_DATA_HEALTH:
      return {
        ...oldState,
        dataHealthArray: action.stats,
      }

    default:
      return oldState
  }
}

export default volunteerDataReducer
